import { scrollTo } from 'ui-utils';
import { setInnerHTML } from 'utils';

onLoad();

export function onLoad(context = document) {
    context.querySelectorAll('.form-widget').forEach(form => {
        form.addEventListener('submitted', e => {
            if (typeof e.detail.data === 'string') {
                setInnerHTML(form, e.detail.data.match(/<form.*?>([\s\S]*?)<\/form>/)[1]);
                scrollTo(form);
            } else
                window.location.href = e.detail.data.successUrl;
        });
    });
}